import qs from "qs";
import { type ComponentPropsWithRef } from "react";

export type VideoIFrameProps<T> = ComponentPropsWithRef<"iframe"> & {
  src: string;
  options?: T;
};

export default function VideoIFrame<T>(props: VideoIFrameProps<T>) {
  const { src, options, ...iframeProps } = props;
  const queryParams = qs.stringify(options, { addQueryPrefix: true });

  return (
    <iframe
      src={`${src}${queryParams}`}
      allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
      allowFullScreen
      {...iframeProps}
    />
  );
}
